import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getActiveInvoice,
  getCreatePastOrder,
  getInvoiceBusinessUnitList,
  getInvoiceSupplierList,
  getAllInvoiceDetailslist,
} from "../../../service/Invoice/InvoiceService";
import { getAllPastOrderDetailslist } from "../../../service/PastOrder/PastOrderService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Multiselect from "../Multiselect";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../components/SpinnerComponent";
import { getAllCurrencylist } from "../../../service/Currency/CurrencyService";
import countryLocales from "./Locale";
import { useTranslation } from "react-i18next";
import instance from "../../../WebApi/WebApi";

export const currencyToLocale = {
  AED: "ar-AE", // UAE Dirham - Arabic (United Arab Emirates)
  ARS: "es-AR", // Argentine Peso - Spanish (Argentina)
  AUD: "en-AU", // Australian Dollar - English (Australia)
  BGN: "bg-BG", // Bulgarian Lev - Bulgarian (Bulgaria)
  BRL: "pt-BR", // Brazilian Real - Portuguese (Brazil)
  CAD: "en-CA", // Canadian Dollar - English (Canada)
  CHF: "de-CH", // Swiss Franc - German (Switzerland)
  CNY: "zh-CN", // Chinese Yuan - Chinese (China)
  CZK: "cs-CZ", // Czech Koruna - Czech (Czech Republic)
  DKK: "da-DK", // Danish Krone - Danish (Denmark)
  EUR: "de-DE", // Euro - German (Germany)
  GBP: "en-GB", // British Pound - English (United Kingdom)
  HKD: "zh-HK", // Hong Kong Dollar - Chinese (Hong Kong)
  HRK: "hr-HR", // Croatian Kuna - Croatian (Croatia)
  HUF: "hu-HU", // Hungarian Forint - Hungarian (Hungary)
  IDR: "id-ID", // Indonesian Rupiah - Indonesian (Indonesia)
  ILS: "he-IL", // Israeli New Shekel - Hebrew (Israel)
  INR: "hi-IN", // Indian Rupee - Hindi (India)
  ISK: "is-IS", // Icelandic Krona - Icelandic (Iceland)
  JPY: "ja-JP", // Japanese Yen - Japanese (Japan)
  KRW: "ko-KR", // South Korean Won - Korean (South Korea)
  MXN: "es-MX", // Mexican Peso - Spanish (Mexico)
  MYR: "ms-MY", // Malaysian Ringgit - Malay (Malaysia)
  NOK: "nb-NO", // Norwegian Krone - Norwegian Bokmål (Norway)
  NZD: "en-NZ", // New Zealand Dollar - English (New Zealand)
  PHP: "fil-PH", // Philippine Peso - Filipino (Philippines)
  PLN: "pl-PL", // Polish Zloty - Polish (Poland)
  RON: "ro-RO", // Romanian Leu - Romanian (Romania)
  RUB: "ru-RU", // Russian Ruble - Russian (Russia)
  SAR: "ar-SA", // Saudi Riyal - Arabic (Saudi Arabia)
  SEK: "sv-SE", // Swedish Krona - Swedish (Sweden)
  SGD: "en-SG", // Singapore Dollar - English (Singapore)
  THB: "th-TH", // Thai Baht - Thai (Thailand)
  TRY: "tr-TR", // Turkish Lira - Turkish (Turkey)
  USD: "en-US", // US Dollar - English (United States)
  ZAR: "en-ZA", // South African Rand - English (South Africa)
};

const Invoice = () => {
  const { t } = useTranslation();
  const [isActive, setActive] = useState("false");
  const handleToggle = (id, isActive) => {
    getActiveInvoice("Invoice", id, isActive ? false : true, (r) => {
      // console.log(r, "response")
      if (r.success === true) {
        getInvoiceDataList();
      } else {
        // toast.error(r.message)
      }
    });
  };
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");
  const [invoiceBusinessDataList, setAllInvoiceBusinessDataList] = useState([]);
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [search, setSearch] = useState("");
  const [invoiceList, setAllInvoiceList] = useState([]);
  const [businessUnit, setBusinessUnit] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [invoiceId, setInvoiceId] = useState("");
  const [isChecked, setIsChecked] = useState("");
  const [myArrayUser, setMyArrayUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [allPastOrderList, setAllPastOrderList] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = invoiceList.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(invoiceList?.length / PER_PAGE);

  async function getAllPastOrderDetailslist1() {
    getAllPastOrderDetailslist().then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllPastOrderList(response?.data?.listPastOrder);
    });
  }

  const toDate = moment(endDate);
  const formattedToDate = toDate.format("YYYY-MM-DD");
  // console.log(formattedToDate, "endDate")

  const onSearch = (e) => {
    setSearch(e.target.value);
    getAllInvoiceDetailslist(
      e.target.value,
      businessUnit,
      supplier,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      setAllInvoiceList(response?.data?.listInvoice);
    });
  };

  useEffect(() => {
    getInvoiceBusniessDataList();
    getInvoiceSupplierDataList();
    getInvoiceDataList();
  }, []);

  //list of business unit
  async function getInvoiceBusniessDataList() {
    getInvoiceBusinessUnitList().then(function (result) {
      const response = result?.data;
      setAllInvoiceBusinessDataList(response?.data?.businessUnitList);
      getInvoiceDataList();
    });
  }

  useEffect(() => {
    getAllPastOrderDetailslist1();
    getCurrencyDataList();
  }, [invoiceList]);

  async function getCurrencyDataList() {
    getAllCurrencylist().then(function (result) {
      // console.log(result?.data, "datadatadatadatada")
      const response = result?.data;

      const defaultCurrencyData = response?.data?.currencyList.filter(
        (item) => item.defaultCurrency
      );
      setCurrencyData(defaultCurrencyData);
      console.log("defaultCurrencyData", defaultCurrencyData);
    });
  }

  console.log("currencyData", currencyData);

  //list of suppliers
  async function getInvoiceSupplierDataList() {
    getInvoiceSupplierList().then(function (result) {
      const response = result?.data;
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);
    });
  }

  //all listing of invoice
  async function getInvoiceDataList() {
    setIsLoading(true);
    getAllInvoiceDetailslist(search).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllInvoiceList(response?.data?.listInvoice);
      setIsLoading(false);
    });
  }
  // console.log(invoiceList, "inininnininn")

  const onBusinessUnit = (e) => {
    setBusinessUnit(e.target.value ? [e.target.value] : "");
    getAllInvoiceDetailslist(
      search,
      e.target.value ? [e.target.value] : "",
      supplier
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllInvoiceList(response?.data?.listInvoice);
    });
  };

  const onSuppliers = (e) => {
    setSupplier(e ? [e] : "");
    getAllInvoiceDetailslist(search, businessUnit, e ? e : "").then(function (
      result
    ) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllInvoiceList(response?.data?.listInvoice);
    });
  };

  const onCheckBox = (e) => {
    const checked = e.target.checked;
    const value = Number(e.target.value);

    if (checked) {
      if (!myArrayUser.includes(value)) {
        setMyArrayUser((prev) => [...prev, value]);
      }
    } else {
      setInvoiceId("");
      setMyArrayUser((prev) => prev.filter((id) => id !== value));
    }
  };

  const selectAll = (e) => {
    const checked = e.target.checked;

    if (checked) {
      const newSelectedIds = invoiceList
        .filter((data) => !data?.isCreated)
        .map((data) => Number(data?.id));
      setMyArrayUser(newSelectedIds);
    } else {
      setMyArrayUser([]);
    }
  };

  const onPastOrder = async (e) => {
    setIsLoading(true);
    // console.log([Number(e.target.value)], "pastpast")
    try {
      const res = await instance.post(`/customer/past-order/add-past-order`, {
        invoiceIds: [Number(e.target.value)],
      });
      const r = res?.data;
      toast.success(r.message);
      // navigate("/department")
      // window.location.reload();
      getInvoiceDataList();
      getAllPastOrderDetailslist1();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const onAllCreatePastOrder = () => {
    getCreatePastOrder(myArrayUser, (r) => {
      // console.log(r, "response")
      if (r.success === true) {
        toast.success(r.message);
        // navigate("/department")
        // window.location.reload();
        getInvoiceDataList();
      } else {
        toast.error(r.message);
      }
    });
  };

  const onFromDate = (e) => {
    setStartDate(e);
    // console.log(e, "eeeeeeeeeeeeeee")
    const fromDate = moment(e).format("YYYY-MM-DD");
    // console.log(fromDate, "fromDate");
    setFinalStartDate(fromDate);
    getAllInvoiceDetailslist(
      search,
      businessUnit,
      supplier,
      fromDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllInvoiceList(response?.data?.listInvoice);
    });
  };

  const onToDate = (e) => {
    setEndDate(e);
    // console.log(e, "eeeeeeeeeeeeeee")
    const toDate = moment(e).format("YYYY-MM-DD");
    setFinalEndDate(toDate);
    getAllInvoiceDetailslist(
      search,
      businessUnit,
      supplier,
      finalStartDate,
      toDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllInvoiceList(response?.data?.listInvoice);
    });
  };

  const _RESET = (e) => {
    e.preventDefault();
    setSearch("");
    setBusinessUnit("");
    setSupplier("");
    setFinalStartDate("");
    setFinalEndDate("");
    setStartDate("");
    setEndDate("");
    setSelectedOptions([]);
    getAllInvoiceDetailslist("", [], [], "", "").then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr")
      setAllInvoiceList(response?.data?.listInvoice);
    });
  };
  const formatCurrency = (amount, currency = "USD") => {
    const selectedLocale = countryLocales.find(
      (item) => item.country === currency
    )?.code;

    return new Intl.NumberFormat(selectedLocale, {
      maximumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain invoice">
        <Leftpanel breadcm="Invoice" />
        <div className="dbRight">
          <Header link="/dashboard" title="Invoices" description="" />
          <div className="commonBase">
            <div className="dbtableTop mb-4">
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("Search")}
                  onChange={onSearch}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              {/* <div className="dbtableSrchbg">
                {myArrayUser.length ? (
                  <button
                    className="commonButton"
                    onClick={onAllCreatePastOrder}
                  >
                    <i className="fa-solid fa-plus"></i> {t("Create Order")}
                  </button>
                ) : (
                  <button className="commonButton" disabled>
                    <i className="fa-solid fa-plus"></i> {t("Create Order")}
                  </button>
                )}
                &nbsp;
                <button className="commonButton" onClick={_RESET}>
                  {t("Reset")}
                </button>
              </div> */}
            </div>

            <div className="dbtableTop">
              &nbsp;
              <div className="dbtableSrchbg invDs">
                <div className="dateSelect">
                  <DatePicker
                    selectsStart
                    selected={startDate}
                    onChange={onFromDate}
                    // startDate={startDate}
                    placeholderText="From"
                    dateFormat="yyyy-MM-dd"
                  />
                  &nbsp;
                  <DatePicker
                    selectsEnd
                    selected={endDate}
                    onChange={onToDate}
                    endDate={endDate}
                    startDate={startDate}
                    minDate={startDate}
                    placeholderText="To"
                  />
                </div>
                <div className="invMulslct">
                  <Multiselect
                    onSuppliers={onSuppliers}
                    options={invoiceSupplierDataList.map(
                      (item) => item.AccountingSupplierParty
                    )}
                    type={"Suppliers"}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                  />
                </div>
                &nbsp;&nbsp;
                {/* <select className='form-control mr-0' onChange={onBusinessUnit}>
                                    <option selected={businessUnit===''} value="">All Business unit</option>
                                    {invoiceBusinessDataList?.map((d) => (
                                        <option value={d?.AccountingCustomerParty} selected={d?.AccountingCustomerParty===businessUnit}>{d?.AccountingCustomerParty}</option>
                                    ))}
                                </select> */}
                {/* <select className='form-control mr-0' onChange={onSuppliers}>
                                    <option selected={supplier===''} value="">All Suppliers</option>
                                    {invoiceSupplierDataList?.map((d) => (
                                        <option value={d?.AccountingSupplierParty} selected={d?.AccountingSupplierParty===supplier} >{d?.AccountingSupplierParty}</option>
                                    ))}
                                </select> */}
              </div>
            </div>

            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("Invoice Id")}</th>
                    <th>{t("Date")}</th>
                    <th>{t("Business unit")}</th>
                    <th>{t("Supplier")}</th>
                    <th>{t("Amount")}</th>
                    <th>
                      <input type="checkbox" onChange={selectAll} />
                    </th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}
                <tbody>
                  {currentPageData?.map((d) => (
                    <tr className={d?.isActive ? null : "inactive"}>
                      <td data-label="Invoice Id">
                        <Link
                          to={`/invoicedetails?id=${d?.id}&orderId=${
                            allPastOrderList.filter(
                              (item) =>
                                item.filterInvoiceId ===
                                d?.invoice?.Invoice?.ID?._text
                            )[0]?.id
                          }&invoiceId=${
                            allPastOrderList.filter(
                              (item) =>
                                item.filterInvoiceId ===
                                d?.invoice?.Invoice?.ID?._text
                            )[0]?.invoiceId
                          }`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {d?.invoice?.Invoice?.ID?._text}
                        </Link>
                      </td>

                      <td data-label="Date" className="dateTxt">
                        <Link to={`javascript:void(0)`}>
                          {d?.invoice?.Invoice?.IssueDate?._text}
                        </Link>
                      </td>
                      <td data-label="Business unit">
                        <Link to={`javascript:void(0)`}>
                          {d?.PastOrders?.Department?.BusinessUnit?.name}
                        </Link>
                      </td>
                      <td data-label="Supplier">
                        <Link
                          to={`/supplierdetailsinfo?id=${167}`}
                          style={{ color: "rgb(13, 110, 253)" }}
                        >
                          {
                            d?.invoice?.Invoice?.AccountingSupplierParty?.Party
                              ?.PartyName.Name?._text
                          }
                        </Link>
                      </td>
                      <td data-label="Total Amount">
                        <Link to={`javascript:void(0)`}>
                          {/* {
                            d?.invoice?.Invoice?.LegalMonetaryTotal
                              .PayableAmount?._text
                          } */}
                          {currencyData[0]?.name} &nbsp;
                          {formatCurrency(
                            Number(
                              d?.invoice?.Invoice?.LegalMonetaryTotal
                                .PayableAmount?._text
                            ),
                            currencyData[0]?.name
                          )}
                        </Link>
                      </td>
                      <td data-label="&nbsp;">
                        {d?.isCreated ? (
                          ""
                        ) : (
                          <input
                            type="checkbox"
                            checked={myArrayUser.includes(d?.id)}
                            value={d?.id}
                            onChange={onCheckBox}
                          />
                        )}
                      </td>
                      <>
                        {myArrayUser.includes(d?.id) ? (
                          <td data-label="">
                            {d?.isCreated ? (
                              <>
                                <Link
                                  to={`/pastorderdetail?id=${
                                    allPastOrderList.filter(
                                      (item) =>
                                        item?.filterInvoiceId ===
                                        d?.invoice?.Invoice?.ID?._text
                                    )[0]?.id
                                  }&invoiceId=${
                                    allPastOrderList.filter(
                                      (item) =>
                                        item?.filterInvoiceId ===
                                        d?.invoice?.Invoice?.ID?._text
                                    )[0]?.invoiceId
                                  }`}
                                  style={{ color: "rgb(13, 110, 253)" }}
                                >
                                  <i className="fa-solid fa-check"></i>
                                  {
                                    allPastOrderList.filter(
                                      (item) =>
                                        item?.filterInvoiceId ===
                                        d?.invoice?.Invoice?.ID?._text
                                    )[0]?.id
                                  }
                                </Link>
                              </>
                            ) : (
                              <button
                                className="commonButton "
                                onClick={onPastOrder}
                                value={d?.id}
                                style={{ padding: "4px 9px", fontSize: "13px" }}
                              >
                                {t("Create Order")}
                              </button>
                            )}
                          </td>
                        ) : (
                          <td data-label="">
                            {d?.isCreated ? (
                              <>
                                <Link
                                  to={`/pastorderdetail?id=${
                                    allPastOrderList.filter(
                                      (item) =>
                                        item.filterInvoiceId ===
                                        d?.invoice?.Invoice?.ID?._text
                                    )[0]?.id
                                  }&invoiceId=${
                                    allPastOrderList.filter(
                                      (item) =>
                                        item.filterInvoiceId ===
                                        d?.invoice?.Invoice?.ID?._text
                                    )[0]?.invoiceId
                                  }`}
                                  style={{ color: "rgb(13, 110, 253)" }}
                                >
                                  <i className="fa-solid fa-check"></i>
                                  {
                                    allPastOrderList.filter(
                                      (item) =>
                                        item?.filterInvoiceId ===
                                        d?.invoice?.Invoice?.ID?._text
                                    )[0]?.id
                                  }
                                </Link>
                              </>
                            ) : (
                              <button
                                className="commonButton invBtn"
                                disabled
                                onClick={onPastOrder}
                                style={{ padding: "4px 9px", fontSize: "13px" }}
                              >
                                {t("Create Order")}
                              </button>
                            )}
                          </td>
                        )}
                      </>
                      <td data-label="Action">
                        <button
                          onClick={() => handleToggle(d?.id, d?.isActive)}
                          className="beye"
                        >
                          <i className="fa-light fa-eye"></i>
                          <i className="fa-light fa-eye-slash"></i>
                        </button>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={"← Previous"}
                nextLabel={"Next →"}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoice;
